import edapWrapper from '@homeaway/edap-wrapper';

export const MULTIUNIT_ITEM_CLICK = 'multiunit.item.click';
export const MULTI_UNIT_BUTTON_CLICK = 'multiunit.button.click';
export const MULTI_UNIT_RESULT_COUNT = 'multiunit.result.count';
export const MULTI_UNIT_HIT_EXPOSED = 'multiunit.hit.exposed';

export const triggerMultiUnitHitExposedEDAPEvent = (data) => {
    edapWrapper().push({
        name: MULTI_UNIT_HIT_EXPOSED,
        data,
        options: {
            delayProcessing: false
        }
    });
};
